import { privateApi } from 'services';
import { CreateTalentpool, Talentpool, TalentpoolTalentCount, UpdateTalentpool } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const createTalentpool = (businessAccountId: string, talentpool: CreateTalentpool): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/leads/talentpools`, talentpool);

const archive = (talentpoolId: string): Promise<void> =>
    privateApi.post<void>(`talentpools/${talentpoolId}/archive`, undefined, {}, true);

const unarchive = (talentpoolId: string): Promise<void> =>
    privateApi.post<void>(`talentpools/${talentpoolId}/unarchive`, undefined, {}, true);

const updateTalentpool = (talentpoolId: string, talentpool: UpdateTalentpool): Promise<void> =>
    privateApi.put<void>(`talentpools/${talentpoolId}`, talentpool);

const fetchTalentpoolTalentCounts = (businessAccountId: string): Promise<TalentpoolTalentCount[]> =>
    privateApi.get<TalentpoolTalentCount[]>(`business-accounts/${businessAccountId}/talentpools-talent-counts`);

export const TalentpoolGateway = {
    createTalentpool,
    archive,
    unarchive,
    updateTalentpool,
    fetchTalentpoolTalentCounts,
};

const cancelableFetchTalentpools = (businessAccountId: string): Promise<Talentpool[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<Talentpool[]>(
        `business-accounts/${businessAccountId}/leads/talentpools`,
    );

const cancelableFetchTalentpool = (talentpoolId: string): Promise<Talentpool> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<Talentpool>(`talentpools/${talentpoolId}`);

const cancelableFetchTalentpoolTalentCounts = (businessAccountId: string): Promise<TalentpoolTalentCount[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentpoolTalentCount[]>(
        `business-accounts/${businessAccountId}/talentpools-talent-counts`,
    );

export const CancelableTalentpoolGateway = {
    cancelableFetchTalentpools,
    cancelableFetchTalentpool,
    cancelableFetchTalentpoolTalentCounts,
};
